import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Sort = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.155 6.72a.5.5 0 1 0 .69-.725l-3-2.857a.5.5 0 0 0-.69 0l-3 2.857a.5.5 0 0 0 .69.724L4 4.667V11.5a.5.5 0 0 0 1 0V4.667l2.155 2.052Zm1.69 2.56a.5.5 0 0 0-.69.725l3 2.857a.5.5 0 0 0 .69 0l3-2.857a.5.5 0 1 0-.69-.724L12 11.333V4.5a.5.5 0 0 0-1 0v6.833L8.845 9.281Z"
        fill={color}
      />
    </svg>
  )
})

export default Sort
